import React from 'react'
import { Tooltip } from 'antd'
import { Wrapper, Label, Chip, ChipsContainer } from './styles'

const PrimaryChips = ({ selectedValues, onChange, availableOptions, label }) => {
  return (
    <Wrapper name={label}>
      <Label>{label}</Label>
      <ChipsContainer>
        {availableOptions.map((av) => (
          <>
            {av.tooltip && (
              <Tooltip key={av.value} title={av.tooltip || av.label} placement="top">
                <Chip
                  onClick={() => onChange(av)}
                  selected={selectedValues && selectedValues.some((ev) => ev.value === av.value)}
                >
                  {av.label}
                </Chip>
              </Tooltip>
            )}
            {!av.tooltip && (
              <Chip
                onClick={() => onChange(av)}
                selected={selectedValues && selectedValues.some((ev) => ev.value === av.value)}
              >
                {av.label}
              </Chip>
            )}
          </>
        ))}
      </ChipsContainer>
    </Wrapper>
  )
}

export default PrimaryChips
